// @flow
import * as React from 'react';
import { Link } from 'react-router-dom';
import safeUrl from '../util/safeUrl';
import { FormattedMessage, FormattedHTMLMessage } from 'react-intl';

import type { AppStateType } from '../Types';

import "../css/Home.css";

type Props = {
  appState: AppStateType
}

class HomePage extends React.Component<Props> {
  componentWillMount() {
    this.props.appState.changeAvatar('');
  }

  toggleLanguage() {
    // in case of multiple languages, make each language map to a different link
    let currLang = this.props.appState.language;
    let newLang;
    if (currLang == "en") {newLang = "es"}
    else {newLang = "en"}

    let  that = this;
    setTimeout(function() {
      that.props.appState.changeLanguage(newLang);
      window.location = '/';
      window.location.reload(); // forces a reload even if there is a # in the URL
    }, 100);

  }

  render() {
    // if we got to this page (by clicking the back button, for example) log out
    // so that the user doesn't mistakenly think they are logged out and leave
    // the computer with their data still accessible
    this.props.appState.logOut();

    return (
      <div className="page home">
        <img src={safeUrl('/images/women-with-babies.jpg')} className='banner' alt='Mothers with Babies' />

        <h1>
          <FormattedMessage id='app.home.header' defaultMessage='Welcome to My IKIDS Report.' />
        </h1>

        <p className='intro'>
          <FormattedHTMLMessage id='app.home.intro' defaultMessage='In this website you will be able to see your chemical test results.' />
        </p>

        <Link to={`/login`} className='button'>
          <FormattedMessage id='get_started' defaultMessage='a empezar' />
        </Link>

        {//
        // <p className="switch-language" onClick={() => this.toggleLanguage()}>
        //   <FormattedMessage id='switch_language' defaultMessage='Switch Language' />
        // </p>
      }
      </div>
    );
  }
}

export default HomePage;



// WEBPACK FOOTER //
// ./src/pages/HomePage.js